import React from "react";
import {UiModal, UiModalClose} from "shared/uikit";
import {observer} from "mobx-react";
import {BookModel} from "shared/models";
import {BookItemRow} from "./../BookItemRow";

import './styles.scss';


type PropsType = {
    book: BookModel;
    isOpened: boolean;
    onClose: () => void;
}

export const BookItemModalInfo = observer(({book, isOpened, onClose}: PropsType) => {
    return (
        <UiModal isOpened={isOpened} styleBody={{maxWidth: 860}} className="book-item-modal-info">
            <UiModalClose onClick={onClose}/>
            <BookItemRow book={book}/>
        </UiModal>
    )
});
